import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
}

export function Input({
  label,
  error,
  leftIcon,
  className = "",
  id,
  ...props
}: InputProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, "-");
  return (
    <div className='flex flex-col gap-1'>
      {label && (
        <label htmlFor={inputId} className='text-sm font-medium text-gray-700'>
          {label}
        </label>
      )}
      <div className='relative'>
        {leftIcon && (
          <div className='absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400'>
            {leftIcon}
          </div>
        )}
        <input
          id={inputId}
          className={[
            "w-full border rounded-xl py-2.5 px-4 text-base text-gray-900 placeholder-gray-400",
            "focus:outline-none focus:ring-2 focus:ring-secondary-400 focus:border-transparent",
            "disabled:opacity-50 disabled:bg-gray-50",
            error ? "border-red-400" : "border-gray-200",
            leftIcon ? "pl-10" : "",
            className,
          ].join(" ")}
          {...props}
        />
      </div>
      {error && <p className='text-xs text-red-500 mt-0.5'>{error}</p>}
    </div>
  );
}
